import { underscore } from '@ember/string';
import UUID from 'uuid-js';
import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  keyForRelationship(key) {
    const underscored = underscore(key);
    return `${underscored}_id`;
  },
  normalize(type, payload) {
    const newPayload = {
      ...payload
    };
    newPayload.id = UUID.create().toString();
    return this._super(type, newPayload);
  },
  serialize(snapshot) {
    return this._super(snapshot, {
      includeId: false
    });
  }
});